




import { defineComponent } from "@vue/composition-api";
import { Viewer } from "@toast-ui/vue-editor";
import "@toast-ui/editor/dist/toastui-editor-viewer.css";

export default defineComponent({
  name: "WysiwygViewer",
  components: {
    Viewer,
  },
  props: { value: { type: String } },
});
